import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=c5f231aa&scoped=true"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=c5f231aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f231aa",
  null
  
)

export default component.exports